import toLower from "lodash";

export default function isPhoneValid(country, number) {
  const map = {
    [toLower(country)]: () => ({ valid: true }),
    nigeria: () => validateNGNPhone(number),
    ghana: () => validateGHSPhone(number),
    kenya: () => validateKenyanPhone(number),
  };

  return map[String(country).toLowerCase()]();
}

export function cleanPhone(countryCode, number) {
  if (!number && !countryCode) return;
  let phone;
  // countryCode = String(countryCode).replace(/\D+/g, "");
  // number = String(number).replace(/\D+/g, "");

  if (String(number).substring(0, String(countryCode).length) === countryCode) {
    phone = String(number).replace(countryCode, "");
  }

  //   console.log(countryCode, number, phone);
  return phone ?? number;
}

function validateNGNPhone(number) {
  // const code = '+233';
  if (number && String(number).length > 10)
    return { valid: false, message: "Invalid phone number" };
  if (number && String(number).length < 2)
    return { valid: false, message: "Invalid phone number" };
  return { valid: true, message: "valid" };
}

function validateGHSPhone(number) {
  // const code = '+233';
  if (number && String(number).length > 9)
    return { valid: false, message: "Invalid phone number" };
  if (number && String(number).length < 2)
    return { valid: false, message: "Invalid phone number" };
  return { valid: true, message: "valid" };
}

function validateKenyanPhone(number) {
  // validation body
  if (number && String(number).length > 0) return { valid: true };
  return { valid: false, message: "Invalid phone number" };
}
